import {Component, EventEmitter, HostBinding, HostListener, Input, Output} from '@angular/core';

@Component({
  selector: 'bzg-button-toggle',
  templateUrl: './button-toggle.component.html',
  styleUrls: ['./button-toggle.component.scss'],
  host: { 'class': 'bz-btn-toggle' }
})
export class BzgButtonToggleComponent {

  @Input() value: any;
  @Input() id: string;
  @Output() public clicked: EventEmitter<any> = new EventEmitter();
  @HostBinding('class.bz-btn-toggle--active') active = false;
  constructor() {
  }
  @HostListener('click')
  onClick() {
    this.clicked.emit(this.value);
  }

}
